import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import trasportApi from "../../api/trasportApi";
import { ShimmerTable } from "react-shimmer-effects";
import Main from "../layout/Main";
import Confirm from '../Confirm';
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";
import InfoPill from "../InfoPill";
import Helmet from "react-helmet";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";

// React Icons Starts Here
import { FiEdit } from "react-icons/fi";
import { FaTrashAlt } from "react-icons/fa";
import { BsChevronRight } from "react-icons/bs";
import { ItemEdit } from ".";
//React Icons Ends here.


const ItemList = () => {
  const [body, setBody] = useState([]);
  const [modalShow, setModalShow] = React.useState(false);
  const [itemRec, setItem] = React.useState({});
  const [modalShowEditItem, setmodalShowEditItem] = React.useState(false);


  useEffect(() => {
    fetchAlItems();
  }, []);

  const fetchAlItems = () => {
    async function init() {
      const item = await trasportApi.fetchAllItem();
      if (item) {
        setBody(item);
      } else {
        setBody([]);
      }
    }
    init();
  }

  // Create table headers consisting of 4 columns.
  const header = [
    { title: "Item Name", prop: "name", isFilterable: true },
    { title: "Price Deduction", prop: "price_deduction", isFilterable: true },
    { title: "Deduction Weight", prop: "deduction_weight", isFilterable: true },
   
    
  ];
  
    header.push({
      title: "Actions",
      prop: "id",
      cell: (row) => (
        <div>
          <Button className='btn-sm mx-2' onClick={() => editItemList(row)}><FiEdit /></Button>
          <Button variant="danger" className='btn-sm mx-2' onClick={() => handleDelete(row)}><FaTrashAlt/></Button>
        </div>
      ),
    });


  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const labels = {
    beforeSelect: " ",
  };

  const createItem = () => {
    setItem({});
    setmodalShowEditItem(true);
  };

  const submitItemList = () => {
   
  }

  const editItemList = (row) => {
    setmodalShowEditItem(true);
    setItem(row);
  }

  const handleDelete = (row) => {
    console.log(row);
    setModalShow(true);
    setItem(row);
  }
  const deleteItemRec = async () => {    
    const result = await trasportApi.deleteItem(itemRec.id);
    if (result.success) {
      setItem('');
      setModalShow(false);
      fetchAlItems();
    }
  }

  return (
    <Main>
      <>
        <Helmet>
          <title>{LIST_TAB_TITLE.ItemList}</title>
        </Helmet>
      </>

      {modalShowEditItem &&
        <ItemEdit
          show={modalShowEditItem}
          onHide={() => setmodalShowEditItem(false)}
          submitItemList={submitItemList}
          itemRec={itemRec ? itemRec : {}}
        />
      }

      {modalShow &&
        <Confirm
          show={modalShow}
          onHide={() => setModalShow(false)}
          deleteItemRec={deleteItemRec}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="item"
        />}

      <Row className="g-0">
        <Col lg={2} className="mx-2">
          <Link to="/home" style={{ "text-decoration": "none" }}>
            Home
          </Link>
          {/* <i className="fa-solid fa-chevron-right"></i>  */}
          <BsChevronRight/>
          Item List
        </Col>
        <Col lg={12} className="p-lg-4">
          {body ? (
            <DatatableWrapper
              body={body}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 10,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Filter />
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-start align-items-center"
                >
                  <PaginationOptions labels={labels} />
                  <InfoPill left="Total" right={body?.length} />
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Button
                    className="btn-md"
                    variant="primary"
                    onClick={() => createItem(true)}
                  >
                    New Item
                  </Button>
                </Col>
              </Row>

              <Table striped className="data-table">
                <TableHeader />

                <TableBody />
              </Table>

              <Pagination />
            </DatatableWrapper>
          ) : (
            <ShimmerTable row={10} col={8} />
          )}
        </Col>
        <Col lg={2}></Col>
      </Row>
    </Main>
  );
};
export default ItemList;
